export const AssetSubtypesSelectFieldMessages = {
  placeholder: {
    id: 'Pages.MerchantSelection.Page.assetSubtypePlaceholder',
    description: 'Locate businesses by product',
  },
}
